<template>
	<div class="cv">
		<div class="cv__elm">
			<!-- ///////////// -->
			<!-- BACKWARD LINK -->
			<div class="cv__elm-backward">
				<div
					v-if="!device.isMobile"
					class="cv__elm-backward-link"
					@click="onGoBack"
				>
					<IconArrowLeft color="rgb(49, 49, 50)" />
				</div>
				<div class="cv__elm-backward-label">Подтверждение</div>
			</div>

			<!-- //////////////// -->
			<!-- Форма подтверждения -->
			<ConfirmationForm />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapGetters } from "vuex";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import ConfirmationForm from "@/components/confirmation/ConfirmationForm.vue";

@Options({
	components: { ConfirmationForm, IconArrowLeft },
	computed: {
		...mapGetters("instanceModule", {
			device: "getDevice",
		}),
	},
})
export default class ConfirmationView extends Vue {
	// ************************************************************
	// Define mapGetters
	public device: { isMobile: boolean };

	/**
	 * Переход на предыдущую страницу
	 */
	public onGoBack() {
		return this.$router.back();
	}
}
</script>

<style scoped lang="scss">
.cv {
	display: flex;
	justify-content: center;
	user-select: none;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-backward {
		display: flex;
		padding: 24px 0;
	}

	&__elm-backward-link {
		cursor: pointer;
	}

	&__elm-backward-label {
		padding-left: 12px;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 0 12px;
			min-width: 100px;
		}

		&__elm-backward {
			padding: 16px 0 12px;
		}

		&__elm-backward-label {
			padding-left: 0;
			font-size: 18px;
		}
	}
}
</style>
